import { numeric } from './listPdf';

/**
 * HOURS, never money: the crew export's per-day O/T (camera + non-camera) and travel (to + from)
 * and its week totals (owner 2026-11-01: "no money yet" — hours only). Kept OUT of
 * `utils/timesheetExport.js` on purpose: that module is held arithmetic-free by
 * `server/tests/regressions/crew-cost-path-parity-manifest.test.js` §4a (it lays out the
 * server's money and must never compute any). These are the crew's own typed hour values summed
 * for reading; nothing here sees a rate.
 *
 * `sumHours(...values)` — the sum to 2dp, or `null` when every value is blank (a blank is not a
 * zero: a day with no O/T typed prints blank, not 0).
 */
export function sumHours(...values) {
  const nums = values.map(numeric).filter((n) => n !== null);
  if (nums.length === 0) return null;
  return Math.round(nums.reduce((s, n) => s + n, 0) * 100) / 100;
}
